import React from 'react';

function VideoUpload() {
  /* eslint-disable max-len */
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path
        d="M21.8181818,2 L2.18181818,2 C0.970909069,2 0,2.97090894 0,4.18181818 L0,17.2727273 C0,18.4727276 0.970909069,19.4545455 2.18181818,19.4545455 L7.63636364,19.4545455 L7.63636364,21.6363636 L16.3636364,21.6363636 L16.3636364,19.4545455 L21.8181818,19.4545455 C23.0181821,19.4545455 23.9890906,18.4727276 23.9890906,17.2727273 L24,4.18181818 C24,2.97090894 23.0181821,2 21.8181818,2 Z M21.8181818,17.2727273 L2.18181818,17.2727273 L2.18181818,4.18181818 L21.8181818,4.18181818 L21.8181818,17.2727273 Z M16.3636364,10.7272727 L8.72727273,15.0909091 L8.72727273,6.36363636 L16.3636364,10.7272727 Z"
        id="Fill-2"
      />
    </svg>
  );
  /* eslint-enable */
}

export default VideoUpload;



// WEBPACK FOOTER //
// ./src/common/icons/VideoUpload.js